export default __webpack_public_path__ + "static/media/yellow-light.163c162e.svg";